import './App.css';
import { AppRoutes } from './routes/AppRoutes';

function App() {
  return (
    <div className="app-shell">
      <AppRoutes />
    </div>
  );
}

export default App;
